// extracted by mini-css-extract-plugin
module.exports = {"Infos":"styles_Infos__17tXQ","Infos__h2":"styles_Infos__h2__2b9-R","Infos__text":"styles_Infos__text__12Mqg","Infos__backButton":"styles_Infos__backButton__eGFar"};